import { defineNotificationCategory } from './types';

export const trialsDescriptor = defineNotificationCategory('trials', {
  actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/subscriptions`,
  pills: () => ['Trial'],
});

export const trialExtendedDescriptor = defineNotificationCategory('trial_extended', {
  actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/subscriptions`,
  pills: () => ['Trial'],
});

export const capacityOrphanedInstanceDescriptor = defineNotificationCategory(
  'capacity_orphaned_instance',
  {
    actionUrl: (_data, organizationId) =>
      `/org-id/${organizationId}/settings/capacity/orphaned-data`,
    pills: (data) => (data.instanceName ? [data.instanceName, 'Capacity'] : ['Capacity']),
  },
);
